import { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchRecords from './SearchRecords';
import {
    Box,
    Container
} from '@mui/material';
import { _axios } from 'src/plugins/axios';
import moment from 'moment';
import commonService from 'src/service/common';
import { DateUtils } from 'src/utils/dateUtils';

class MedicineMIS extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: {
                dateRange: []
            },
            filterOptions: {
                entityRequested: []
            },
            hideEntityRequested: true,
            preSignedUrl: null,
            warningMessage: null
        }
    }

    applyFilters = async () => {
        const payload = {};
        if (this.state.filter.dateRange.length == 2) {
            let startDate = new Date(this.state.filter.dateRange[0]);
            let endDate = new Date(this.state.filter.dateRange[1]);
            payload['apptDateBegin'] =
                startDate.getFullYear() +
                '-' +
                ('0' + (startDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + startDate.getDate()).slice(-2);
            payload['apptDateEnd'] =
                endDate.getFullYear() +
                '-' +
                ('0' + (endDate.getMonth() + 1)).slice(-2) +
                '-' +
                ('0' + endDate.getDate()).slice(-2);
        }

        await this.getMisData(payload);
    }

    getMisData = async (payload) => {
        this.setState({ preSignedUrl: null, warningMessage: null});

        //setting Default payload
        if (Object.keys(payload).length == 0) {
            payload = {
                ...payload,
                apptDateBegin: DateUtils.getCurrentYearStartDate(),
                apptDateEnd: DateUtils.getDate()
            }
        }

        if(((new Date(payload.apptDateEnd) - new Date(payload.apptDateBegin)) / (24 * 60 * 60 * 1000)) > 10) {
            this.setState({warningMessage: true});
            return;
        }
        
        _axios.post('/pharma/misData', payload, {
            ignoreLoading: false,
            timeout: 120000,
            headers: {
                authtoken: commonService.getAuthToken(),
                'Content-Type': 'application/json'
            },
        }).then((response) => {
            if (response?.data?.isSuccess) {
                this.setState({ preSignedUrl: response?.data?.presignedUrl });
            }
        }).catch(err => {
            alert(err.message);
        })
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>Medicine | MIS</title>
                </Helmet>
                <Box
                    sx={{
                        backgroundColor: 'background.default',
                        minHeight: '100%',
                        py: 2
                    }}
                >
                    <Container maxWidth={false}>
                        <SearchRecords
                            filterOptions={this.state.filterOptions}
                            filter={this.state.filter}
                            hideEntityRequested={this.state.hideEntityRequested}
                            setFilters={(value) => this.setState({ filter: value })}
                            onRefresh={() => this.applyFilters()}
                        />
                    </Container>
                    {
                        this.state.preSignedUrl ?
                            <div className='to-noteContainer' style={{
                                marginTop: 30,
                                cursor: 'pointer'
                            }}>
                                <a className='to-noteHeader' href={this.state.preSignedUrl}>Click here to download report</a>
                            </div>
                            :
                            null
                    }
                    {
                        this.state.warningMessage ?
                            <div className='to-noteContainer mis-errorNoteContainer' style={{
                                marginTop: 30,
                                cursor: 'pointer'
                            }}>
                                <a className='to-noteHeader mis-errorNoteHeader'>Please select date range of 10 days</a>
                            </div>
                            :
                            null
                    }
                </Box>

            </>
        );
    }
}

export default MedicineMIS;